<div class="tab-strip">

	<div #tabItemContainer *ngFor="let item of items;trackBy:trackByIndex;let i=index;"
		 (click)="onTabItemClick(item)"
		 (mouseenter)="onTabMouseEnter(item,$event)" (mouseleave)="onTabMouseLeave()"
		 [ngClass]="{'tab-item-container':true,'active': item === activeItem,
		  			'hover': hoveredItem===item}">
		<div class="tab-content" [ngClass]="{'shrink-for-edit': showEditIcon && hoveredItem === item}">
			<ng-container [ngTemplateOutlet]="tabItemTemplate"
						  [ngTemplateOutletContext]="{$implicit: item, index: i, active: item === activeItem, hover: item === hoveredItem }">
			</ng-container>
		</div>
		<i *ngIf="showEditIcon && (hoveredItem===item || editedItem===item)"
		   [title]="'EditTab' | cpActionTranslate"
		   class="cp-icon-edit cp-icon-color-1"
		   (click)="onEditItemClick($event,item)">
		</i>
	</div>

	<div *ngIf="canAddTabs || canRemoveTabs " class="actions-container">
		<i #addTabIcon *ngIf="canAddTabs" class="cp-icon-procedure_add cp-icon-color-1"
		   [title]="'AddTab' | cpActionTranslate"
		   (click)="onAddItemClick()">
		</i>
		<i *ngIf="canRemoveTabs" class="cp-icon-delete cp-icon-color-1"
		   [title]="'RemoveTab' | cpActionTranslate"
		   [ngClass]="{'disabled': items.length <= 1}"
		   (click)="removeItemClick.emit(activeItem)">
		</i>
	</div>
</div>
